var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutputChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 1069,
    height: 191.564,
    viewBox: "0 0 1069 191.564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M91.9385 142.017L6.31228 163.559V188.979H1067.5V2.42564L981.874 36.4619L941.466 43.7862L896.248 58.4347H858.726L807.735 73.0832L793.304 83.8542H750.972L700.943 90.3168L642.255 99.7953H600.885L564.326 109.705L517.183 99.7953L468.117 121.768L413.277 137.278L375.756 149.342L318.992 142.017L293.978 126.076L269.926 121.768L242.987 126.076H179.489L134.271 142.017H91.9385Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M6.31228 163.559L91.9385 142.017H134.271L179.489 126.076H242.987L269.926 121.768L293.978 126.076L318.992 142.017L375.756 149.342L413.277 137.278L468.117 121.768L517.183 99.7953L564.326 109.705L600.885 99.7953H642.255L700.943 90.3168L750.972 83.8542H793.304L807.735 73.0832L858.726 58.4347H896.248L941.466 43.7862L981.874 36.4619L1067.5 2.42564",
    stroke: "#22D3EE",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M93.8609 154.081H1.5V191.564H1065.57V12.7661L1011.7 1.56431L953.009 26.553L868.345 42.494L851.99 75.2378L792.34 104.966L767.325 108.843H699.017L613.391 79.5462H512.371L472.925 75.2378L420.972 97.2106L369.019 104.966L347.853 117.46H293.976H243.947L192.956 141.587L152.548 149.773L93.8609 154.081Z",
    fill: "url(#paint1_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M1.5 154.081H93.8609L152.548 149.773L192.956 141.587L243.947 117.46H293.976H347.853L369.019 104.966L420.972 97.2106L472.925 75.2378L512.371 79.5462H613.391L699.017 108.843H767.325L792.34 104.966L851.99 75.2378L868.345 42.494L953.009 26.553L1011.7 1.56431L1065.57 12.7661",
    stroke: "#0C45CC",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 511.411,
    y1: -45.3975,
    x2: 516.437,
    y2: 177.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41FFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41FFE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 533.537,
    y1: 1.5643,
    x2: 547.797,
    y2: 175.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1384FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1384FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutputChart);
export default __webpack_public_path__ + "static/media/output_chart.82ecdddf11943d5df47530c0f908df21.svg";
export { ForwardRef as ReactComponent };